import { client } from '../apiClient';

export interface CreatePeriodicReportModel {
  projectId: number;
  provider: string;
  type: string;
  config: {
    integrationId?: number;
    parameters?: Record<string, any>;
  };
  schedule: {
    day?: number;
    hour?: number;
    dayOfWeek?: number;
    dayOfMonth?: number;
    timezone?: string;
  };
  status?: string;
}

export interface PeriodicReportResponse {
  id: number;
  accountId: number;
  projectId: number;
  provider: string;
  status: string;
  type: string;
  config: any;
  schedule: any;
  lastExecuted?: string;
  created: string;
  updated: string;
}

const PERIODIC_REPORTS_ENDPOINT = '/periodic-reports';

export class PeriodicReportService {
  static async createPeriodicReport(model: CreatePeriodicReportModel): Promise<PeriodicReportResponse> {
    const response = await client(true, true).post(`${PERIODIC_REPORTS_ENDPOINT}/create`, model);
    return response.data.data;
  }

  static async getPeriodicReports(type?: string, provider?: string): Promise<PeriodicReportResponse[]> {
    let url = type 
      ? `${PERIODIC_REPORTS_ENDPOINT}/type/${type}`
      : PERIODIC_REPORTS_ENDPOINT;
    
    if (provider) {
      const separator = url.includes('?') ? '&' : '?';
      url = `${url}${separator}provider=${provider}`;
    }
    
    const response = await client(true, true).get(url);
    return response.data.data;
  }

  static async getPeriodicReport(id: number): Promise<PeriodicReportResponse> {
    const response = await client(true, true).get(`${PERIODIC_REPORTS_ENDPOINT}/${id}`);
    return response.data.data;
  }

  static async updatePeriodicReport(id: number, updates: Partial<CreatePeriodicReportModel>): Promise<PeriodicReportResponse> {
    const response = await client(true, true).put(`${PERIODIC_REPORTS_ENDPOINT}/update/${id}`, updates);
    return response.data.data;
  }

  static async deletePeriodicReport(id: number): Promise<boolean> {
    const response = await client(true, true).delete(`${PERIODIC_REPORTS_ENDPOINT}/delete/${id}`);
    return response.status === 200;
  }

  static async activatePeriodicReport(id: number): Promise<PeriodicReportResponse> {
    const response = await client(true, true).post(`${PERIODIC_REPORTS_ENDPOINT}/activate/${id}`, { status: 'ACTIVE' });
    return response.data.data;
  }

  static async deactivatePeriodicReport(id: number): Promise<PeriodicReportResponse> {
    const response = await client(true, true).post(`${PERIODIC_REPORTS_ENDPOINT}/deactivate/${id}`, { status: 'PAUSED' });
    return response.data.data;
  }
}
